module.exports = __webpack_public_path__ + "img/Češka.bb78051b.png";